import { Page, parseToNumberOrNull } from '@touche-lts/panel-ui/dist'
import { ProductsFilterDTO, ProductsTableEntityDTO } from 'models'
import { FetchOptions } from 'services'
import { StatisticsTableSearchProps, StatisticsTableSortProps } from './statistics-table-base.types'
import { PaginationSearchBase } from '..'
import {
  initialStatisticsTablePaginationProps,
  initialStatisticsTableSearchProps,
  statisticsNeedTimeoutProps
} from './statistics-table-base.utils'
import moment from 'moment';
// import { RootStore } from 'mobx-stores'

export class StatisticsTableBase extends PaginationSearchBase<
  StatisticsTableSortProps,
  StatisticsTableSearchProps,
  ProductsTableEntityDTO
> {
 private rootStoreStats:any
  constructor (rootStore:any) {
    super({
      initialPaginationProps: initialStatisticsTablePaginationProps,
      initialSearchProps: initialStatisticsTableSearchProps,
      needTimeoutProps: statisticsNeedTimeoutProps
    })
    this.rootStoreStats = rootStore
  }

  public handleSearchResult = (data: Page<ProductsTableEntityDTO>): void => {
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data as any)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get productFilter (): Partial<ProductsFilterDTO> {
    return {
        activeSkusMax: this.searchProps.activeSkusMax,
        activeSkusMin: this.searchProps.activeSkusMin,
        dateEnd: this.rootStoreStats.statisticsStore.endPeriod,
        dateStart: this.rootStoreStats.statisticsStore.periodDate,
        productName: this.searchProps.productName,
        revenueTotalMax: this.searchProps.maxRevenue,
        revenueTotalMin: this.searchProps.minRevenue,
        soldMax: this.searchProps.soldMax,
        soldMin: this.searchProps.soldMin,
        stockMax: this.searchProps.stockMax,
        stockMin: this.searchProps.stockMin
    }
  }
}
